function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
var _templateObject;
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React, { useCallback, useState, useEffect } from 'react';
import { PlayArrowFillIcon } from '@applyboard/ui-icons';
import { Button } from "../Button";
import { useStyle, List, ListItem, IMAGE_SIZE } from "./style";
import { Slideshow } from "./Slideshow";
import { ImageWithFallback } from "../ImageWithFallback";
import { generateGalleryItems } from "./utils";
import styled from '@emotion/styled';
var StyledImageWithFallback = styled(ImageWithFallback)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 8px;\n  object-fit: cover;\n  transition: linear filter 200ms;\n  cursor: zoom-in;\n\n  &:hover {\n    filter: brightness(0.5);\n  }\n"])));
export function Gallery(_ref) {
  var images = _ref.images,
    video = _ref.video,
    onViewPhoto = _ref.onViewPhoto;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    openIndex = _useState2[0],
    setOpenIndex = _useState2[1];
  var _useStyle = useStyle(),
    backdropStyle = _useStyle.backdropStyle,
    carouselStyle = _useStyle.carouselStyle,
    rootStyle = _useStyle.rootStyle,
    openButtonStyle = _useStyle.openButtonStyle;
  var onClickFirstImage = useCallback(function () {
    return setOpenIndex(0);
  }, [setOpenIndex]);
  var items = generateGalleryItems(images, video);
  useEffect(function () {
    if (onViewPhoto && openIndex !== null) {
      onViewPhoto(_objectSpread(_objectSpread({}, items[openIndex]), {}, {
        photoNumber: openIndex + 1
      }));
    }
  }, [onViewPhoto, openIndex]);
  return items !== null && items !== void 0 && items.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: rootStyle,
    id: "gallery-container"
  }, /*#__PURE__*/React.createElement(StyledImageWithFallback, {
    src: items[0].optimized,
    alt: items[0].photoFileName,
    srcFallback: items[0].original,
    key: items[0].optimized,
    loading: "eager",
    onClick: onClickFirstImage,
    style: {
      width: IMAGE_SIZE.SCHOOL.main.width,
      height: IMAGE_SIZE.SCHOOL.main.height
    }
  }), /*#__PURE__*/React.createElement(List, null, items === null || items === void 0 ? void 0 : items.slice(1, items.length).map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListItem, {
      key: item.id,
      onClick: function onClick() {
        return setOpenIndex(index + 1);
      }
    }, /*#__PURE__*/React.createElement(StyledImageWithFallback, {
      src: item.optimized // should use thumbnail but most are not too small to work properly
      ,
      srcFallback: item.original,
      alt: item.photoFileName,
      loading: "eager",
      style: {
        width: IMAGE_SIZE.SCHOOL.secondary.width,
        height: IMAGE_SIZE.SCHOOL.secondary.height
      }
    }), item.type === 'video' && /*#__PURE__*/React.createElement("div", {
      style: {
        color: '#e52d27',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        pointerEvents: 'none'
      }
    }, /*#__PURE__*/React.createElement(PlayArrowFillIcon, null)));
  })), /*#__PURE__*/React.createElement(Button, {
    "aria-label": "open slideshow",
    onClick: onClickFirstImage,
    className: openButtonStyle
  }, "View Photos")), /*#__PURE__*/React.createElement(Slideshow, {
    items: items,
    openIndex: openIndex,
    onChange: setOpenIndex,
    classNames: {
      backdropStyle: backdropStyle,
      carouselStyle: carouselStyle
    }
  })) : null;
}